export default __webpack_public_path__ + "static/media/phone-call.674a9e1d.svg";